// PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const PrivateRoute = ({ element }) => {
  const isVerified = Cookies.get('pin-verified') === 'true';
  return isVerified ? element : <Navigate to="/Auth" replace />;
};

export default PrivateRoute;
